import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import claimSagas from './claim/saga';
import pendingclaimSagas from './pendingclaim/saga';
import mailSagas from './mail/saga';
export default function* rootSaga(getState) {
  yield all([authSagas(), claimSagas(), pendingclaimSagas(), mailSagas()]);
}
